const initialStateCountry = {
  country: [],
  update_country: false,
};

export default initialStateCountry;